function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as i, jsx as l } from "react/jsx-runtime";
import { useTheme as s } from "../../hooks.js";
import { useIsInverseVariant as c } from "../../theme-variant-context.js";
import { vars as e } from "../../skins/skin-contract.css-mistica.js";
const v = (_param)=>{
    var { color: t , size: o = 24  } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = c(), a = t !== null && t !== void 0 ? t : n ? e.colors.inverse : e.colors.neutralHigh, { skinName: h  } = s();
    return h.match(/^blau/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: [
            /* @__PURE__ */ l("path", {
                fill: a,
                d: "M6.143 13.214L12 19.071l5.857-5.857c.464-.464.607-1.214.357-1.857-.25-.607-.785-.964-1.393-.964H14.68V2.714A.716.716 0 0013.964 2a.716.716 0 00-.714.714v9.107h3.571s.036 0 .072.072c.036.107.036.25-.036.321L12 17.071l-4.857-4.857c-.072-.071-.072-.214-.036-.321.036-.072.072-.072.072-.072h3.571V2.714A.716.716 0 0010.036 2a.716.716 0 00-.715.714v7.679H7.18c-.608 0-1.143.357-1.393.964-.25.643-.107 1.393.357 1.857z"
            }),
            /* @__PURE__ */ l("path", {
                fill: a,
                d: "M4.143 22h15.714A2.15 2.15 0 0022 19.857V12a.716.716 0 00-.714-.714.716.716 0 00-.715.714v7.857a.716.716 0 01-.714.714H4.143a.716.716 0 01-.714-.714V12a.716.716 0 00-.715-.714A.716.716 0 002 12v7.857A2.15 2.15 0 004.143 22z"
            })
        ]
    })) : /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ l("path", {
            fill: a,
            d: "M11.264 21.488a.947.947 0 00.725.336c.28 0 .546-.123.728-.336l8.863-9.143a1.008 1.008 0 00.16-1.112.962.962 0 00-.874-.56h-3.961l.003-6.596a1.903 1.903 0 00-1.905-1.905h-6.03a1.906 1.906 0 00-1.905 1.905v6.596H3.135a.958.958 0 00-.871.56 1.01 1.01 0 00.144 1.096l.015.016 8.84 9.143zm.728-.812l-8.62-8.913v-.003h3.816a.987.987 0 00.972-.997V4.077c0-.449.364-.816.815-.816h6.03c.452 0 .816.367.816.818l-.003 6.687c0 .549.437.997.972.997h3.843l-8.641 8.913z"
        })
    }));
}, u = v;
export { u as default };
